module.exports = __webpack_public_path__ + "static/media/rezerwacje.88c571ff.svg";